/**
 * The app's form-field geometry — one set of numbers for every text input,
 * phone control and select in the product.
 *
 * These are the values the Contacts form shipped with. They were screen-scoped
 * in `Contacts.tokens.ts` and applied per call site, so Contacts looked one way
 * and every form that did *not* pass an override (Send Invite, and most modals)
 * fell back to `CustomInput`'s much older defaults — a 40px box, an 8px radius,
 * a 14px label and no border of its own. Promoting them here is what makes the
 * chrome constant: the shared components now start from these, and a screen's
 * own `sx` layers on top instead of replacing them.
 *
 * Colours are deliberately absent — they live in `theme.palette.formField.*`
 * and are read straight from there, so a re-skin touches one block.
 *
 * `Contacts.tokens.ts` keeps its own copy of the same numbers for now. Its
 * fields also carry things no other screen has (inline `n/max` counters, a
 * per-breakpoint 46px phone height), so folding it in is a separate change —
 * but the two must not drift.
 */
export const formFieldMetrics = {
  /** Gap between a field's label and its box. */
  labelGap: "6px",
  labelFontSize: "11.5px",
  labelFontWeight: 600,
  /** Tops up MUI's thin space before the required asterisk. */
  asteriskGap: "2px",

  height: 44,
  radius: "10px",
  borderWidth: "1px",
  paddingX: "14px",
  fontSize: "14px",
  fontWeight: 500,

  helperFontSize: "10.5px",
  helperGap: "4px",
} as const;

export default formFieldMetrics;
